import React from 'react';
import { auth } from '../firebase/config';
import { Clock } from 'lucide-react';

function PendingApprovalPage() {
    return (
        <div className="d-flex flex-column align-items-center justify-content-center vh-100 bg-light">
            <div className="card text-center shadow" style={{ maxWidth: '500px' }}>
                <div className="card-body p-5">
                    <Clock size={48} className="text-primary mb-3" />
                    <h1 className="h3">Aprovação Pendente</h1>
                    <p className="lead text-muted">
                        Obrigado por se cadastrar! Sua conta foi criada com sucesso e está aguardando a aprovação de um administrador.
                    </p>
                    <p>Você será notificado por e-mail assim que sua conta for ativada. Se tiver urgência, por favor, entre em contato com nosso suporte.</p>
                    <button className="btn btn-outline-secondary mt-3" onClick={() => auth.signOut()}>
                        Sair
                    </button>
                </div>
            </div>
        </div>
    );
}

export default PendingApprovalPage;